export const DEFAULT_STATE = {
    data: null,
    metadata: null,
    csvdata: null,
    isLoading: false,
};
